import React from 'react';

import type { SvgProps } from '../enums';

export const FlagES: React.FC<SvgProps> = ({ size }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_270_54993"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="16"
      height="12"
    >
      <rect width="16" height="12" fill="white" />
    </mask>
    <g mask="url(#mask0_270_54993)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 0V12H16V0H0Z"
        fill="#FFB400"
      />
      <mask
        id="mask1_270_54993"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="16"
        height="12"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 0V12H16V0H0Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask1_270_54993)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 0V3H16V0H0Z"
          fill="#C51918"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 9V12H16V9H0Z"
          fill="#C51918"
        />
        <rect
          x="2.50403"
          y="5.13599"
          width="0.56"
          height="2.912"
          fill="#F1F9FF"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3.28803 4.63199H2.28003V4.91199H2.44803V5.13599H3.12003V4.91199H3.28803V4.63199Z"
          fill="#C88A02"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3.12003 8.216H3.28803V8.496H2.28003V8.216H2.44803V7.992H3.12003V8.216Z"
          fill="#C88A02"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          // eslint-disable-next-line max-len
          d="M2.78403 4.68799C2.90589 4.68799 2.91828 4.6421 2.99018 4.57357C3.04601 4.52035 3.17603 4.45434 3.17603 4.37999C3.17603 4.20989 3.00052 4.07199 2.78403 4.07199C2.56753 4.07199 2.39203 4.20989 2.39203 4.37999C2.39203 4.46282 2.48157 4.51821 2.54927 4.57357C2.6206 4.63189 2.67296 4.68799 2.78403 4.68799Z"
          fill="#AD1619"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          // eslint-disable-next-line max-len
          d="M2.28003 8.496H3.28803V8.944C3.28803 8.944 3.16203 8.888 3.03603 8.888C2.91003 8.888 2.78403 8.944 2.78403 8.944C2.78403 8.944 2.65803 8.888 2.53203 8.888C2.40603 8.888 2.28003 8.944 2.28003 8.944V8.496Z"
          fill="#005BBF"
        />
        <mask
          id="mask2_270_54993"
          style={{ maskType: 'alpha' }}
          maskUnits="userSpaceOnUse"
          x="2"
          y="8"
          width="2"
          height="1"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            // eslint-disable-next-line max-len
            d="M2.28003 8.496H3.28803V8.944C3.28803 8.944 3.16203 8.888 3.03603 8.888C2.91003 8.888 2.78403 8.944 2.78403 8.944C2.78403 8.944 2.65803 8.888 2.53203 8.888C2.40603 8.888 2.28003 8.944 2.28003 8.944V8.496Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask2_270_54993)" />
        <rect
          x="7.992"
          y="5.13599"
          width="0.56"
          height="2.912"
          fill="#F1F9FF"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.77601 4.63199H7.76801V4.91199H7.93601V5.13599H8.60801V4.91199H8.77601V4.63199Z"
          fill="#C88A02"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.60801 8.216H8.77601V8.496H7.76801V8.216H7.93601V7.992H8.60801V8.216Z"
          fill="#C88A02"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          // eslint-disable-next-line max-len
          d="M8.272 4.68799C8.39387 4.68799 8.40626 4.6421 8.47815 4.57357C8.53398 4.52035 8.664 4.45434 8.664 4.37999C8.664 4.20989 8.4885 4.07199 8.272 4.07199C8.05551 4.07199 7.88 4.20989 7.88 4.37999C7.88 4.46282 7.96954 4.51821 8.03725 4.57357C8.10857 4.63189 8.16093 4.68799 8.272 4.68799Z"
          fill="#AD1619"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          // eslint-disable-next-line max-len
          d="M7.76801 8.496H8.77601V8.944C8.77601 8.944 8.65001 8.888 8.52401 8.888C8.39801 8.888 8.27201 8.944 8.27201 8.944C8.27201 8.944 8.14601 8.888 8.02001 8.888C7.89401 8.888 7.76801 8.944 7.76801 8.944V8.496Z"
          fill="#005BBF"
        />
        <mask
          id="mask3_270_54993"
          style={{ maskType: 'alpha' }}
          maskUnits="userSpaceOnUse"
          x="7"
          y="8"
          width="2"
          height="1"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            // eslint-disable-next-line max-len
            d="M7.76801 8.496H8.77601V8.944C8.77601 8.944 8.65001 8.888 8.52401 8.888C8.39801 8.888 8.27201 8.944 8.27201 8.944C8.27201 8.944 8.14601 8.888 8.02001 8.888C7.89401 8.888 7.76801 8.944 7.76801 8.944V8.496Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask3_270_54993)" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          // eslint-disable-next-line max-len
          d="M2.494 7.83994C2.59496 7.71754 2.65142 7.60618 2.65142 7.48791C2.65142 7.41334 2.62923 7.34893 2.59035 7.29631L2.59692 7.29336C2.59632 7.29363 2.70768 7.24509 2.74645 7.22649C2.81853 7.19194 2.88203 7.15533 2.94394 7.11031C2.98346 7.08156 3.03642 7.05025 3.11715 7.0069L3.2135 6.95568C3.25274 6.93474 3.28196 6.9187 3.3091 6.90295C3.39369 6.85389 3.44958 6.81334 3.49233 6.75912C3.59359 6.63072 3.57257 6.45666 3.43067 6.36005C3.36115 6.31272 3.26734 6.28556 3.12983 6.26418L2.93315 6.23369C2.86734 6.22336 2.80863 6.21372 2.75627 6.20457C3.10055 6.14728 3.59217 6.16834 3.80842 6.27999L4.01395 5.88192C3.57328 5.65439 2.56921 5.67763 2.19415 5.93592C1.91905 6.12538 1.95596 6.41176 2.24219 6.53508C2.36179 6.58661 2.51771 6.6208 2.80623 6.66715C2.75788 6.6952 2.71779 6.72083 2.68044 6.74799C2.64257 6.77553 2.60198 6.79893 2.55276 6.82253C2.52922 6.83382 2.45952 6.86442 2.42756 6.87845L2.42754 6.87846L2.42754 6.87847L2.41148 6.88554C2.17834 6.99155 2.06519 7.1382 2.099 7.40293L2.1173 7.54624L2.15014 7.55632L2.494 7.83994ZM2.20581 7.4696L2.2051 7.47166L2.20564 7.4702L2.20581 7.4696ZM8.353 7.48791C8.353 7.60618 8.40946 7.71754 8.51042 7.83994L8.85429 7.55632L8.88712 7.54624L8.90542 7.40293C8.93923 7.1382 8.82608 6.99155 8.59294 6.88554L8.57688 6.87846C8.54493 6.86444 8.47521 6.83382 8.45166 6.82253C8.40244 6.79893 8.36186 6.77553 8.32398 6.74799C8.28663 6.72083 8.24654 6.6952 8.19819 6.66715C8.48672 6.6208 8.64263 6.58661 8.76223 6.53508C9.04846 6.41176 9.08537 6.12538 8.81027 5.93592C8.43521 5.67763 7.43114 5.65439 6.99047 5.88192L7.196 6.27999C7.41225 6.16834 7.90387 6.14728 8.24815 6.20457C8.1958 6.21372 8.13708 6.22336 8.07127 6.23369L7.87459 6.26418C7.73708 6.28556 7.64327 6.31272 7.57375 6.36005C7.43185 6.45666 7.41083 6.63072 7.51209 6.75912C7.55484 6.81334 7.61074 6.85389 7.69532 6.90295C7.72246 6.9187 7.75168 6.93474 7.79092 6.95568L7.88727 7.0069C7.968 7.05025 8.02096 7.08156 8.06048 7.11031C8.1224 7.15533 8.18589 7.19194 8.25797 7.22649C8.29674 7.24509 8.4081 7.29363 8.4075 7.29336L8.41407 7.29631C8.37519 7.34893 8.353 7.41334 8.353 7.48791Z"
          fill="#AD1619"
        />
        <path
          d="M2.96171 6.19998L3.127 6.23418V6.48055C2.95095 6.62101 2.50403 6.85776 2.50403 6.85776V6.19998H2.96171Z"
          fill="#F1F9FF"
        />
        <path
          d="M8.15731 6.19998L7.99202 6.23418V6.48055C8.16807 6.62101 8.61499 6.85776 8.61499 6.85776V6.19998H8.15731Z"
          fill="#F1F9FF"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          // eslint-disable-next-line max-len
          d="M7.38801 3.60298V3.52099C7.09997 3.31427 6.79833 3.21091 6.4831 3.21091C6.18088 3.07717 5.87499 3.02526 5.5654 3.05517C5.56549 3.05421 5.56553 3.05373 5.56553 3.05373C5.10004 3.00818 4.63093 3.21091 4.63093 3.21091C4.15807 3.21091 3.72601 3.52099 3.72601 3.52099V3.60298L4.29083 4.17025C4.29083 4.17025 4.44975 4.71605 5.56264 4.58799C5.56303 4.58886 5.56323 4.58931 5.56323 4.58931C5.56323 4.58931 6.30041 4.56919 6.3522 4.55196C6.37276 4.54512 6.39407 4.5389 6.41585 4.53254C6.56024 4.49038 6.72508 4.44226 6.82319 4.17025L7.38801 3.60298ZM5.56287 3.0845C5.56054 3.11201 5.55685 3.15681 5.55248 3.21408C5.55802 3.17304 5.56174 3.12998 5.56287 3.0845Z"
          fill="#AD1619"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          // eslint-disable-next-line max-len
          d="M3.75989 3.69923L3.79826 3.65845L4.31111 4.14095C4.40846 4.11477 4.93687 3.98012 5.52711 3.97349V3.97324L5.54957 3.9733L5.57202 3.97324V3.97349C6.22597 3.98084 6.80402 4.14533 6.80402 4.14533C6.80402 4.14533 6.79783 4.19841 6.78278 4.26081C6.79871 4.22814 6.81758 4.19184 6.8394 4.15178L6.8448 4.14478L7.36172 3.65845L7.40009 3.69923L6.88644 4.18249C6.8115 4.3205 6.77376 4.4116 6.77376 4.44944C6.77376 4.50717 6.62357 4.54144 6.33044 4.57663C6.1008 4.6042 5.82978 4.62271 5.60809 4.62548V4.62584L5.57999 4.62574L5.55189 4.62584V4.62548C5.3302 4.62271 5.05918 4.6042 4.82954 4.57663C4.53641 4.54144 4.38622 4.50717 4.38622 4.44944C4.38622 4.44228 4.38487 4.43322 4.38217 4.42229C4.35261 4.38465 4.33183 4.32307 4.318 4.26752C4.30502 4.24154 4.2902 4.21318 4.27354 4.18249L3.75989 3.69923ZM6.62653 4.45054C6.66576 4.4689 6.69721 4.45058 6.72208 4.41542C6.71993 4.42513 6.71858 4.43391 6.71804 4.44178C6.71476 4.44393 6.70972 4.44651 6.70311 4.44929C6.68466 4.45705 6.65649 4.46531 6.61985 4.47367C6.54781 4.4901 6.44528 4.50644 6.32376 4.52103C6.08647 4.54952 5.80431 4.56827 5.57999 4.56974C5.35567 4.56827 5.07351 4.54952 4.83622 4.52103C4.7147 4.50644 4.61217 4.4901 4.54014 4.47367C4.50942 4.46666 4.48465 4.45972 4.46658 4.4531L4.47261 4.45054C4.59495 4.39329 5.40389 4.33958 5.54957 4.33031C5.69525 4.33958 6.50419 4.39329 6.62653 4.45054ZM6.7808 4.44028L6.77995 4.44126L6.78046 4.44055L6.7808 4.44028Z"
          fill="#C88A02"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          // eslint-disable-next-line max-len
          d="M5.55612 2.67352C5.64891 2.67352 5.72412 2.59831 5.72412 2.50552C5.72412 2.41274 5.64891 2.33752 5.55612 2.33752C5.46334 2.33752 5.38812 2.41274 5.38812 2.50552C5.38812 2.59831 5.46334 2.67352 5.55612 2.67352Z"
          fill="#005BBF"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          // eslint-disable-next-line max-len
          d="M5.49343 2.0383H5.6101V2.112H5.68633V2.22867H5.6101V2.462H5.68633V2.57867H5.41602V2.462H5.49343V2.22867H5.41602V2.112H5.49343V2.0383Z"
          fill="#C88A02"
        />
        <rect
          x="5.47198"
          y="2.672"
          width="0.224"
          height="0.728"
          fill="#C88A02"
        />
        <path
          // eslint-disable-next-line max-len
          d="M3.85388 3.64843L3.54626 3.63686C3.6914 2.79807 4.40619 2.38708 5.5484 2.38708C6.69209 2.38708 7.40435 2.79985 7.53857 3.64176L7.12253 3.6854C7.05721 3.2757 6.37098 2.90493 5.55441 2.90493C4.73636 2.90493 3.92531 3.23561 3.85388 3.64843Z"
          fill="#C88A02"
        />
        <path
          opacity="0.3"
          fillRule="evenodd"
          clipRule="evenodd"
          // eslint-disable-next-line max-len
          d="M3.73602 4.63199H7.37602V7.9024C7.37602 7.9024 7.10564 8.99999 5.55602 8.99999C4.00641 8.99999 3.73602 7.87346 3.73602 7.87346V4.63199Z"
          fill="#E1E5E8"
        />
        <mask
          id="mask4_270_54993"
          style={{ maskType: 'alpha' }}
          maskUnits="userSpaceOnUse"
          x="3"
          y="4"
          width="5"
          height="5"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            // eslint-disable-next-line max-len
            d="M3.73602 4.63199H7.37602V7.9024C7.37602 7.9024 7.10564 8.99999 5.55602 8.99999C4.00641 8.99999 3.73602 7.87346 3.73602 7.87346V4.63199Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask4_270_54993)">
          <rect
            x="3.73602"
            y="6.64798"
            width="1.848"
            height="2.184"
            fill="#FFC034"
          />
          <rect
            x="3.73602"
            y="4.57599"
            width="1.848"
            height="2.128"
            fill="#AD1619"
          />
          <rect
            x="5.52802"
            y="6.59198"
            width="1.848"
            height="2.128"
            fill="#AD1619"
          />
          <rect
            x="5.52802"
            y="4.63199"
            width="1.96"
            height="2.072"
            fill="#F1F9FF"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            // eslint-disable-next-line max-len
            d="M6.74139 8.72135C6.74139 8.72135 5.55529 8.8146 5.55529 8.04962C5.55529 8.04962 5.54398 8.72135 4.30548 8.72135V9.32526H6.74139V8.72135Z"
            fill="#F1F9FF"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            // eslint-disable-next-line max-len
            d="M5.55605 7.09598C5.78801 7.09598 5.97605 6.89541 5.97605 6.64798C5.97605 6.40056 5.78801 6.19998 5.55605 6.19998C5.32409 6.19998 5.13605 6.40056 5.13605 6.64798C5.13605 6.89541 5.32409 7.09598 5.55605 7.09598Z"
            fill="#005BBF"
            stroke="#AD1619"
            strokeWidth="0.583333"
          />
        </g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.5 6C4.77614 6 5 5.77614 5 5.5C5 5.22386 4.77614 5 4.5 5C4.22386 5 4 5.22386 4 5.5C4 5.77614 4.22386 6 4.5 6Z"
          fill="#C88A02"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.5 6C6.77614 6 7 5.77614 7 5.5C7 5.22386 6.77614 5 6.5 5C6.22386 5 6 5.22386 6 5.5C6 5.77614 6.22386 6 6.5 6Z"
          fill="#C37C9C"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.5 8C6.77614 8 7 7.77614 7 7.5C7 7.22386 6.77614 7 6.5 7C6.22386 7 6 7.22386 6 7.5C6 7.77614 6.22386 8 6.5 8Z"
          fill="#FFC034"
        />
        <path
          d="M4.5 8C4.77614 8 5 7.77614 5 7.5C5 7.22386 4.77614 7 4.5 7C4.22386 7 4 7.22386 4 7.5C4 7.77614 4.22386 8 4.5 8Z"
          fill="#AD1619"
        />
      </g>
    </g>
  </svg>
);
